import React, {Component} from "react";
import {map} from "lodash";
import BasicDetail from "./BasicDetail";
import SideBar from "./SideBar";
import Loader from "../../../Common/Component/Loader";
import {message} from "antd";
import {errorHandle} from "../../../Common/errorHandle";
import * as yup from "yup";
import axios from 'axios';
import config from '../../../../Lib/Config';

// mapping frequency
const frequency_data = [
  {key: 'Twice Weekly', value: 'twice_weekly'},
  {key: 'Weekly', value: 'weekly'},
  {key: 'Every Other Week', value: 'bi_monthly'},
  {key: 'Monthly', value: 'monthly'},
  {key: 'One-Time', value: 'once'},
]

// mapping property type
const property_type = [
  {key: 'Town House', value: 'townhouse'},
  {key: 'Detached', comment: '<.5 acres. lot', value: 'single_family_small'},
  {key: 'Detached', comment: '>.5 acres. lot - FO to assess', value: 'single_family_large'},
]

// mapping cleaning area
const area_clean = [
  { key: 'Front Yard', value: 'front yard'},
  { key: 'Back Yard', value: 'back yard'},
  { key: 'Right Side', value: 'right side'},
  { key: 'Left Side', value: 'left side'},
  { key: 'Dog Run', value: 'dog run'},
  { key: 'Fenced Area', value: 'fenced area'},
  { key: 'Other', value: ''},
];

// mapping last clean
const last_cleaned = [
  { key: 'Less than 2 weeks', value: 'less_than_2_weeks'},
  { key: '2 to 6 weeks', value: '1-2_months'},
  { key: 'More than 6 weeks', value: '2_months_or_more'}
]

// mapping dog count
const dog_count = [{key: '1', value: '1'}, {key: '2', value: '2'}, {key: '3', value: '3'}, {key: '4+', value: '4'}]
let changeInfo = true;
class ServiceInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      frequency: '',
      areaClean: [],
      add_ons: [],
      propertyType: '',
      lastCleaned: '',
      dogCount: '',
      franchises: [],
      zipcodeCheck: null,
      disposalLocation: '',
      cleaningNotes: '',
      is_btn_active: false,
      is_basic_btn_active: false,
      is_extra_pet: false,
      extra_pet: '',
      errors: {},
      loader: false,
      is_save: false,
      otherCleaning:''
    }
    this.basicDetail = null
    this.sidebar = null
  }

  componentDidMount() {
    const data = {...JSON.parse(sessionStorage.getItem('step1'))};
    const calcData = JSON.parse(sessionStorage.getItem('calcData'));


    this.setState({
      frequency: data?.frequency || '',
      areaClean: data?.areaClean || [],
      propertyType: data?.propertyType || '',
      lastCleaned: data?.lastCleaned || '',
      dogCount: data?.dogCount|| '',
      disposalLocation: data?.disposalLocation || '',
      cleaningNotes: data?.cleaningNotes || '',
      add_ons: data?.add_ons || [],
      coupon_code: calcData?.coupon_code,
    })
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    // errors handle //////////////////////////////////
    if (Object.keys(nextProps?.zipcodeCheck?.errors).length > 0 && nextProps?.zipcodeCheck?.errors !== this.props?.zipcodeCheck?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.zipcodeCheck?.errors)
    }

    if (Object.keys(nextProps?.lead?.errors).length > 0 && nextProps?.lead?.errors !== this.props?.lead?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.lead?.errors)
    }
    ///////////////////////////////////////////////////////////////

    // check zipcode
    if (Object.keys(nextProps?.zipcodeCheck?.data).length > 0 && nextProps?.zipcodeCheck?.data?.results?.length > 0
    && JSON.stringify(nextProps?.zipcodeCheck?.data?.results) !== JSON.stringify(this.state.franchises)) {
      const data = {...JSON.parse(sessionStorage.getItem('step1'))};
      
      const calcData = JSON.parse(sessionStorage.getItem('calcData'));
      let claning_area = data?.areaClean;
      let otherCleaning = this.state.otherCleaning;
      let other = data?.areaClean?.filter(item => { return item !== 'front yard' && item !== 'back yard' && item !== 'right side' && item !== 'left side' && item !== 'dog run' && item !== 'fenced area' });
      let idx = data?.areaClean?.findIndex(item => { return item !== 'front yard' && item !== 'back yard' && item !== 'right side' && item !== 'left side' && item !== 'dog run' && item !== 'fenced area' });
      if (other && other.length > 0) {
        claning_area[idx] = '';
        otherCleaning =  other && other.length > 0 ? other[0] : '';
      }
      this.setState({zipcodeCheck: true, franchises: nextProps?.zipcodeCheck?.data?.results, loader: false,
        frequency: data?.frequency || '',
        areaClean: claning_area || [],
        otherCleaning:otherCleaning,
        propertyType: data?.propertyType || '',
        lastCleaned: data?.lastCleaned || '',
        dogCount: data?.dogCount|| '',
        disposalLocation: data?.disposalLocation || '',
        cleaningNotes: data?.cleaningNotes || '',
        add_ons: data?.add_ons || [],
        coupon_code: calcData?.coupon_code
      }, () => this.onPriceCalc(true));
    } else if (JSON.stringify(nextProps?.zipcodeCheck?.data?.results) !== JSON.stringify(this.state.franchises)) {
      this.setState({zipcodeCheck: false, franchises: [], loader: false,
        frequency: '',
        areaClean: [],
        propertyType: '',
        lastCleaned: '',
        dogCount: '',
        disposalLocation: '',
        cleaningNotes: '',
        add_ons: [],
        coupon_code: ''
      }, () => this.onPriceCalc(true, false));
    }

    if (Object.keys(nextProps?.serviceOrderEnquiry?.enquiryList).length > 0
      && JSON.stringify(this.state.enquiryList) !== JSON.stringify(nextProps?.serviceOrderEnquiry?.enquiryList) && !this.props?.isBackClick) {
      const order = nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0];
      const obj = {frequency: order?.frequency,
        add_ons: order?.service_add_ons || [],
        areaClean: order?.area_to_clean || [],
        propertyType: order?.property_type || '',
        lastCleaned: order?.last_cleaned || '',
        dogCount: order?.pet_count >= 4 ? 0 : order?.pet_count?.toString(),
        zipcodeCheck: order?.field_office_uuid ? true : false,
        disposalLocation: order?.disposal_location || '',
        cleaningNotes: order?.cleaning_notes || '',
        extra_pet: order?.pet_count >= 4 ? order?.pet_count?.toString() : 0, is_extra_pet: order?.pet_count >= 4,
        coupon_code: order?.coupon_code
      }
      this.setState({...obj,  enquiryList: nextProps?.serviceOrderEnquiry?.enquiryList, loader: false}, () => this.onPriceCalc(true));
    }

    if (Object.keys(nextProps?.serviceOrderEnquiry?.nonServiceableEnquiry).length > 0
      && JSON.stringify(nextProps?.serviceOrderEnquiry?.nonServiceableEnquiry) !== JSON.stringify(this.props?.serviceOrderEnquiry?.nonServiceableEnquiry)) {
      this.setState({loader: false});
    }
  }

  // validate basic detail
  validateBasicInfo = (value) => {
    const {is_basic_btn_active} = this.state;
    if (is_basic_btn_active !== value) {
      this.setState({is_basic_btn_active: value});
    }
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on service detail change
  onTextChange = (e, type) => {
    const calcFields = ['frequency', 'areaClean', 'propertyType', 'lastCleaned', 'dogCount', 'add_ons'];
    const value = type === 'bool' ? e.target.checked : e.target.value;
    if (e.target.name === 'dogCount' && e.target.value === '4') {
      this.setState({is_extra_pet: true})
    } else if(e.target.name === 'dogCount') {
      this.setState({is_extra_pet: false, extra_pet: ''})
    }
    this.setState({ [e?.target?.name]: value }, () => this.onPriceCalc(calcFields.includes(e?.target?.name)))
  }

  // on extra pet change
  onExtraPet = (e) => {
    const value = e.target.value;
    if (parseInt(value) >= 4 || value === '') {
      this.setState({[e?.target?.name]: value}, () => this.onPriceCalc(true))
    }
  }

  // on clean area changed
  onCleanAreaChanged = (e, value) => {
    const {areaClean} = this.state;
    const idx = areaClean.indexOf(value);
    if (idx <= -1) {
      areaClean.push(value);
    } else {
      areaClean.splice(idx, 1);
    }
    this.setState({areaClean},  () => this.onPriceCalc(true))
  }

  // on add ons change
  onAddOnsChange = (e, value, item) => {
    const {add_ons} = this.state;

    const idx = add_ons.findIndex(obj => obj.add_on_uuid === item.uuid)
    if (idx > -1) add_ons.splice(idx, 1)

    if (e.target.checked) {
      add_ons.push({...item, add_on_uuid: item?.uuid, is_recurring: value})
    }
    this.setState({add_ons},  () => this.onPriceCalc(true));
  }

  // validate required field
  validate = (action) => {
    this.basicDetail.validate().then((res) => {
      if (res === 'success') {
        this.sidebar.leadValidate().then((sidebar_res) => {
          if (sidebar_res === 'success') {
            const {frequency, propertyType, lastCleaned, dogCount, is_extra_pet, extra_pet, areaClean, otherCleaning} = this.state;
            const { zipcodeCheck } = this.props;
            const schema = yup.object().shape({
              frequency: yup.string().required("Frequency is required"),
              propertyType: yup.string().required("Property type is required"),
              dogCount: yup.string().when("is_extra_pet", {is: false, then: yup.string().required("Dog count is required")}),
              extra_pet: yup.string().test('match', 'Extra dog count is required', (extra_pet) => {
                if (is_extra_pet) {
                  return parseInt(extra_pet) > 0;
                } else {
                  return true
                }
              }),
              areaClean: areaClean.length === 0 ? yup.string().required('Please select at least one cleaning area') : null,
              otherCleaning: areaClean.indexOf("") > -1 && (otherCleaning === undefined || otherCleaning === '') ? yup.string().required('Please enter the Other cleaning area.') : null,
              lastCleaned: yup.string().when("frequency", { is: 'once', then: yup.string().required("Last cleaned is required") }),
            });

            const data = {frequency, propertyType, lastCleaned, dogCount, is_extra_pet, extra_pet};
            const basicDetail = JSON.parse(sessionStorage.getItem('basicDetail'));
            schema.validate(data, { abortEarly: false }).then(() => {
              if (basicDetail?.is_address_manually) {
                this.setState({is_btn_active: true, errors: {}})
                this.storeInLocal()
                if (action === 'save') {
                  if (this.state.zipcodeCheck) {
                    this.setState({is_save: true}, () => this.onSaveLead())
                  }
                  else {this.props.onNonServiceableEnquiry()}
                } else if (action === 'savenext') {
                  if (this.state.zipcodeCheck) {
                    this.setState({is_save: true}); 
                    this.onSaveLead();
                    this.props.onTabChange(1, false);
                    changeInfo = true;
                  } else {
                    this.props.onNonServiceableEnquiry()
                  }
                }
                else if (action === 'next') {
                  this.setState({is_save: false}, () => 
                    this.props.onTabChange(1, false))
                  changeInfo = true;
                }
              } else {
                axios.post(`${config.getHost()}service-order/validate_address/`, {
                  field_office_uuid: zipcodeCheck?.data?.results[0]?.uuid,
                  address: basicDetail?.google_address
                }).then((response) => {
                  if (Object.keys(response).length > 0 && response?.data?.is_valid) {
                    this.setState({is_btn_active: true, errors: {}})
                    this.storeInLocal()
                    if (action === 'save') {
                      if (this.state.zipcodeCheck) {
                        this.setState({is_save: true}, () => this.onSaveLead())
                      }
                      else {this.props.onNonServiceableEnquiry()}
                    } else if (action === 'savenext') {
                      if (this.state.zipcodeCheck) {
                        this.setState({is_save: true}); 
                        this.onSaveLead();
                        this.props.onTabChange(1, false);
                        changeInfo = true;
                      } else {
                        this.props.onNonServiceableEnquiry()
                      }
                    }
                    else if (action === 'next') {
                      this.setState({is_save: false}, () => 
                        this.props.onTabChange(1, false))
                      changeInfo = true;
                    }
                  } else {
                    message.error('Sorry, we could not find that address in OptimoRoute. Please check the address and try again, or enter latitude/longitude coordinates.');  
                  }
                }).catch((error) => {
                  message.error('Sorry, we could not find that address in OptimoRoute. Please check the address and try again, or enter latitude/longitude coordinates.');
                });
              }
            }).catch((error) => {
              let err_data = {};
              map(error?.inner, (item) => {err_data[item.path] = item.message})
              this.setState({errors: err_data, is_btn_active: false})
            });
          }
        }) // end of side bar callback validation
      }
    }) // end basic detail validate
  };

  // on price calc
  onPriceCalc = (isCalcField = false, isStoreInLocal = true) => {
    if (isStoreInLocal) this.storeInLocal()
    if (isCalcField && this.state.zipcodeCheck){
      this.props.priceCalc()
    } 
  }

  // store data in local storage
  storeInLocal = () => {
    const {
      frequency,
      areaClean,
      propertyType,
      lastCleaned,
      dogCount,
      zipcodeCheck,
      disposalLocation,
      cleaningNotes,
      add_ons,
      extra_pet,
      is_extra_pet,
      franchises,
      coupon_code,
      otherCleaning
    } = this.state;

    let area_to_clean = [];

    if (areaClean && areaClean.length > 0) {
      area_to_clean = areaClean;
      const idx = area_to_clean.indexOf("");
      
      if (idx > -1) {
        area_to_clean[idx] = otherCleaning;
      }
    }

    sessionStorage.setItem('calcData', JSON.stringify({coupon_code}));
    sessionStorage.setItem('step1', JSON.stringify({
      frequency,
      add_ons,
      areaClean: area_to_clean,
      otherCleaning,
      propertyType,
      lastCleaned,
      dogCount,
      zipcodeCheck,
      disposalLocation,
      cleaningNotes,
      extra_pet,
      is_extra_pet,
      franchises
    }));

    const data = {...JSON.parse(sessionStorage.getItem('step1'))};
    let claning_area = data?.areaClean;
    let otherCleaning1 = otherCleaning;
    
    let other = data?.areaClean?.filter(item => { 
      return item !== 'front yard' && item !== 'back yard' && 
        item !== 'right side' && item !== 'left side' && 
        item !== 'dog run' && item !== 'fenced area' 
    });
    let idx = data?.areaClean?.findIndex(item => { 
      return item !== 'front yard' && item !== 'back yard' && 
        item !== 'right side' && item !== 'left side' && 
        item !== 'dog run' && item !== 'fenced area'
    });
    if (other && other.length > 0) {
      claning_area[idx] = '';
      otherCleaning1 =  other && other.length > 0 ? other[0] : '';
    }

    this.setState({ areaClean: claning_area || []});
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3724></DP-3724>
   */
  onSaveLead = () => {
    this.setState({loader: true})
    setTimeout(() => {
      this.storeInLocal();
      // Promise.allSettled([this.props.updateLeadDetail('lead'), this.props.addCallLog(), setTimeout(() => this.props.onAddEnquiry('step1'), 1000)]).then((result) => {
      Promise.allSettled([this.props.addCallLog(), setTimeout(() => this.props.onAddEnquiry('step1'), 1000)]).then((result) => {
        const isReject = result.filter(x => x.status === "rejected")
        this.setState({loader: false})
        if (isReject?.length > 0) {
          setTimeout(() => errorHandle(isReject?.[0]?.reason), 1000)
        } else {
          this.setState({loader: true})
          setTimeout(() => {
            if (this.state.is_save) {
              this.props.getServiceOrderEnquiry({user__uuid: this.props?.customerId, limit: 1}); // get service order enquiry
              // this.props.history.goBack()
              this.setState({is_save: false, loader: false})
            }
          }, 2000)
        }
      })
    }, 1000)
  }

  onCancel = () => {
    this.props.history.goBack();
    sessionStorage.removeItem('basicDetail');
    sessionStorage.removeItem('step1');
    sessionStorage.removeItem('step2');
    sessionStorage.removeItem('calcData');
    sessionStorage.removeItem('pricingCalc');
    sessionStorage.removeItem('logCall');
  }

  render() {
    const {
      frequency,
      areaClean,
      add_ons,
      propertyType,
      lastCleaned,
      dogCount,
      franchises,
      zipcodeCheck,
      extra_pet,
      is_extra_pet,
      errors,
      loader,
      disposalLocation,
      cleaningNotes,
      otherCleaning
    } = this.state;

    return (
      <div className="container">
        {loader && <Loader />}
        <div className="fluid-block">
          <div className="article-block">
            <BasicDetail
              ref={(ref) => this.basicDetail = ref}
              setLoader={this.props.setLoader}
              customerId={this.props.customerId}
              currentTab={this.props.currentTab}
              changeInfo={changeInfo}
              validateBasicInfo={this.validateBasicInfo}
              isBackClick={this.props.isBackClick}
              // reducers
              zipcodeCheck={this.props.zipcodeCheck}
              lead={this.props.lead}
              DeletePhoneNumber={this.props.DeletePhoneNumber}
              GoogleApi={this.props.GoogleApi}
              // apis
              getLeadById={this.props.getLeadById}
              checkZipCode={this.props.checkZipCode}
              resetCheckZipcode={this.props.resetCheckZipcode}
              deletePhoneNumber={this.props.deletePhoneNumber}
              getGeocodeAddress={this.props.getGeocodeAddress}
              resetGeocodeAddress={this.props.resetGeocodeAddress}
            />
            <div className={`adetail ${zipcodeCheck ? '' : 'disabled'}`}>
              <h3>Base Cleaning Requirements</h3>
              <div className="form-block">
                <div className="frow">
                  <h4>How often do you need your yard cleaned?</h4>
                  <div className="oplist">
                    {map(frequency_data, (item, index) => {
                      return (
                        <div className="inline-checks" key={`frequency${index}`}>
                          <label htmlFor={item?.value} className={`${frequency === item?.value ? 'active' : ''}`}>
                            <input
                              type="radio"
                              id={item?.value}
                              name="frequency"
                              disabled={!zipcodeCheck}
                              className=""
                              value={item?.value}
                              onChange={() => this.onTextChange({target: {name: 'frequency', value: item?.value}})}
                            />
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )}
                    )}
                  </div>
                  {errors?.['frequency'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['frequency']}</label> : ''}
                </div>
                <div className="frow md-label">
                  <h4>What’s your place like?</h4>
                  <div className="oplist">
                    {map(property_type, (item, index) => {
                      return (
                        <div className="inline-checks" key={`propertyType${index}`}>
                          <label htmlFor={item?.value} className={`${propertyType === item?.value ? 'active' : ''}`}>
                            <input type="radio" id={item?.value} name='propertyType' disabled={!zipcodeCheck} className="" value={item?.value} onChange={() => this.onTextChange({target: {name: 'propertyType', value: item?.value}})}/>
                            <span>{item?.key} <br/> {item?.comment}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                  {errors?.['propertyType'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['propertyType']}</label> : ''}
                </div>
                <div className="frow md-label">
                  <h4>How many pups on property?</h4>
                  <div className="oplist">
                    {map(dog_count, (item, index) => {
                      return (
                        <div className="inline-checks" key={`dogCount${index}`}>
                          <label htmlFor={`dogCount${index}`} className={`${dogCount === item?.value ? 'active' : ''}`}>
                            <input type="radio" id={`dogCount${index}`} name='dogCount' disabled={!zipcodeCheck} className="" value={item?.value} onChange={() => {
                              this.onTextChange({target: {name: 'dogCount', value: item?.value}})
                              this.onExtraPet({target: {name: 'extra_pet', value: '4'}})
                            }}/>
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                  {is_extra_pet &&
                  <div className="fitem">
                    <input
                      type='text'
                      name='extra_pet'
                      disabled={!zipcodeCheck}
                      value={extra_pet}
                      onChange={(e) => this.onNumericInputChange(e.target.value) && this.onExtraPet(e) }
                      placeholder="Please specify the exact number of dogs" />
                  </div>
                  }
                  {errors?.['dogCount'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['dogCount']}</label> : ''}
                  {errors?.['extra_pet'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['extra_pet']}</label> : ''}
                </div>
                <div className="frow md-label">
                  <h4>When was your yard last cleaned?</h4>
                  <div className="oplist">
                    {map(last_cleaned, (item, index) => {
                      return (
                        <div className="inline-checks" key={`lastCleaned${index}`}>
                          <label htmlFor={item?.value} className={`${lastCleaned === item?.value ? 'active' : ''}`}>
                            <input type="radio" id={item?.value} name='lastCleaned' disabled={!zipcodeCheck} className="" value={item?.value} onChange={() => this.onTextChange({target: {name: 'lastCleaned', value: item?.value}})}/>
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                  {errors?.['lastCleaned'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['lastCleaned']}</label> : ''}
                </div>
                <hr/>
                <h3>Customizable the Clean</h3>

                <div className="frow sm-label">
                  <h4 className="flex">Areas to clean <small>1 area included in price, add ${franchises?.[0]?.additional_cleaning_area_price ? franchises?.[0]?.additional_cleaning_area_price : '0'}/visit for each additional area. </small></h4>
                  <div className="oplist">
                    {map(area_clean, (item, index) => {
                      const isIncluded = areaClean?.includes(item?.value)
                      return (
                        <div className="inline-checks" key={`areaClean${index}`}>
                          <label htmlFor={item?.value} className={isIncluded ? "active" : ''}>
                            <input
                              type="checkbox"
                              id={item?.value}
                              name={item?.value}
                              disabled={!zipcodeCheck}
                              className=""
                              value={item?.value}
                              checked={areaClean.includes(item?.value)}
                              onChange={(e) => this.onCleanAreaChanged(e, item?.value)}
                            />
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )}
                    )}
                    <div className="from-group w-100">
                      <div className="fitem">
                        <input 
                          type="text"
                          id="bi_monthly1" 
                          name="bi_monthly" 
                          className="" 
                          placeholder="Additional other areas to clean"
                          value={otherCleaning}
                          onChange={(e) => {
                            this.setState({otherCleaning: e.target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {errors?.['areaClean'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['areaClean']}</label> : ''}
                {errors?.['otherCleaning'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['otherCleaning']}</label> : ''}
              </div>
              <div className="form-block flex flex-start flex-wrap">
                <h4 className="flex">Additional Services</h4>
                <div className="frow sm-label flex flex-start flex-wrap">

                  {
                    map(franchises?.[0]?.add_on, (item, index) => {
                      const currentAddOn = add_ons.filter(obj => obj.add_on_uuid === item.uuid)
                      const eachVisit = currentAddOn.length > 0 ? currentAddOn?.[0]?.is_recurring : false;
                      const firstVisit = currentAddOn.length > 0 ? !currentAddOn?.[0]?.is_recurring : false;

                      if (item?.is_active) {
                        return (
                          <div className="oplist flex flex-column selected" key={`addons${index}`}>
                            <h5>{item?.name} <br/> +${item?.cost_per_visit} per visit</h5>
                            <div className="flex">
                              <div className="inline-checks">
                                <label htmlFor={`firstvisit${index}`} className={firstVisit ? "active" : '' }>
                                  <input type="checkbox" id={`firstvisit${index}`} name="is_recurring" disabled={!zipcodeCheck} className="" value={!item?.is_recurring}
                                    onChange={(e) => this.onAddOnsChange(e, false, item)} />
                                  <span>First Visit</span>
                                </label>
                              </div>
                              <div className="inline-checks">
                                <label htmlFor={`eachvisit${index}`}  className={eachVisit ? "active" : '' }>
                                  <input type="checkbox" id={`eachvisit${index}`} name="is_recurring" disabled={!zipcodeCheck} className="" value={item?.is_recurring}
                                    onChange={(e) => this.onAddOnsChange(e, true, item)}/>
                                  <span>Each Visit</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    })
                  }
                </div>
              </div>
              <div className="form-block">
                <div className="frow">
                  <h4>Scooped waste disposal location</h4>
                  <p>Our standard policy is to double bag the scooped waste, tie it securely to contain odor, and place it in your garbage can. Please let us know where the garbage can is located or if you’d like the bagged waste placed elsewhere.</p>
                  <div className="form-group">
                    <div className="fitem">
                      <input type="text" placeholder="Scooped Waste Dispotal Location" disabled={!zipcodeCheck} value={disposalLocation} name="disposalLocation" onChange={(e) => this.onTextChange(e)}/>
                    </div>
                  </div>
                </div>
                <div className="frow">
                  <h4>Cleaning Notes</h4>
                  <p>Any special instructions about your property that we should know? (e.g. gate code, yard aces etc.)</p>
                  <div className="form-group">
                    <div className="fitem">
                      <input type="text" placeholder="Additional cleaning notes" disabled={!zipcodeCheck} value={cleaningNotes} name="cleaningNotes" onChange={(e) => this.onTextChange(e)}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <SideBar
            ref={(ref) => this.sidebar = ref}
            customerId={this.props.customerId}
            coupon_code={this.state.coupon_code}
            setCouponCode={(value) => this.setState({coupon_code: value})}
            // reducers
            zipcodeCheck={this.props.ZipcodeCheck}
            PricingCalc={this.props.PricingCalc}
            CallLog={this.props.CallLog}
            //
            priceCalc={this.props.priceCalc}
            getCallLogList={this.props.getCallLogList}
            frequency={frequency}
            currentTab={this.props.currentTab}
            serviceOrderEnquiry={this.props.serviceOrderEnquiry}
            RepresentativeList={this.props.RepresentativeList} // reducer
            getRepresentativeList={this.props.getRepresentativeList}
          />
        </div>
        <div className="fix-btn-grp">
          <button className="btn btn-white" onClick={() => this.onCancel()}>Cancel</button>
          <button className={`btn btn-warning`} onClick={() => this.validate('save')}>Save Lead</button>
          {zipcodeCheck ? <button className={`btn btn-warning`} onClick={() => this.validate('savenext')}>Next: GO TO BILLING</button> : ''}
        </div>
      </div>
    )
  }
}

export default ServiceInfo;
